import { enumValidator } from '#validation/common/validators';
import { SsoEnforcementType } from '../constants';
export const ssoEnforcementTypeValidator = enumValidator({
    values: SsoEnforcementType,
    invalidValueError: 'sso.enforcementType.invalid',
});
